import { el } from 'redom';

import application from 'application';

class UploadingRecordingView {

  constructor() {

    this.initialDataSize = null;
    this.timeoutReference = null;
    this.isMounted = false;

    const spinner = el('ht-spinner');
    const uploadingInformationLabel = el('label.uploading-information-label', 'Please do not refresh. Uploading remaining recording.');

    this.uploadedPercentageLabel = el('label.uploaded-percentage-label', '0% uploaded.');

    const innerContainer = el('.uploading-recording-view-inner-container', [spinner, uploadingInformationLabel, this.uploadedPercentageLabel]);

    this.el = el('.uploading-recording-view-main', innerContainer);

  }

  onmount() {
    this.isMounted = true;
    this.timeoutReference = setTimeout(this.tryUpdateUploadedPercentage.bind(this), 100);
  }

  onunmount() {
    this.isMounted = false;
    if (this.timeoutReference !== null) {
      clearTimeout(this.timeoutReference);
      this.timeoutReference = null;
    }
  }

  displayProcessingLabel() {

    this.uploadedPercentageLabel.textContent = '100% uploaded. Processing...';

  }

  tryUpdateUploadedPercentage() {

    if (this.isMounted === false) {
      return;
    }

    const dataSize = application.eventSystem.getBufferedDataSize();

    if (dataSize === 0) {
      this.displayProcessingLabel();
      return;
    }

    if (this.initialDataSize === null) {
      this.initialDataSize = dataSize;
    }

    const uploadedPercentage = Math.ceil(100 - ((dataSize / this.initialDataSize) * 100));

    this.uploadedPercentageLabel.textContent = `${uploadedPercentage}% uploaded.`;

    if (this.isMounted === true) {
      this.timeoutReference = setTimeout(this.tryUpdateUploadedPercentage.bind(this), 100);
    }

  }

}

export default UploadingRecordingView;